module.exports = __webpack_public_path__ + "img/logo.1d244bcb.png";